<template>
  <div>
    <md-card id="reports" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">cloud_upload</i>
        </div>
        <h4 class="title">Screening Package Ingest</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm"> <label>Search</label><md-input v-model="currentSearchTxt" /> </md-field>
          </div>

          <div class="md-layout-item md-size-20">
            <md-field>
              <label for="currentType">Date</label>
              <md-select v-model="currentFilterDate" name="currentFilterDate">
                <md-option v-for="(type, index) in filterDateOptions" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20">
            <md-field>
              <label for="currentType">Status</label>
              <md-select v-model="currentFilterStatus" name="currentFilterStatus">
                <md-option v-for="(type, index) in filterStatusOptions" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20" v-if="organizations.length > 2">
            <md-field>
              <label for="currentType">Organization</label>
              <md-select v-model="currentOrganization" name="organization">
                <md-option v-for="(type, index) in organizations" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div :class="[{ 'md-size-20': organizations.length > 2 }, { 'md-size-40': organizations.length <= 2 }]"
            class="md-layout-item" style="align-items: end">
            <div class="md-layout md-gutter md-layout-item"
              style="display: flex; align-items: center; justify-content: right">
              <md-button class="md-icon-button md-primary" @click="handleSearch">
                <md-icon>search</md-icon>
                <md-tooltip md-direction="bottom">Filter packages</md-tooltip>
              </md-button>
              <md-button class="md-icon-button md-primary" @click="handleRefresh">
                <md-icon>refresh</md-icon>
                <md-tooltip md-direction="bottom">Refresh list</md-tooltip>
              </md-button>
            </div>
          </div>
        </div>
      </md-card-header>

      <md-card-content>
        <md-table id="packages-table" v-if="!isLoading" v-model="tableData"
          class="table-shopping table-striped table-hover">
          <md-table-row>
            <md-table-empty-state :md-description="`No packages found for this time frame or search criteria`"
              md-label="No packages found" />
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }"
            :style="item.Exception === 'SUCCESS' ? 'cursor:pointer' : 'pointer-events: none'"
            @click="openPackageImages(item)">
            <md-table-cell></md-table-cell>

            <md-table-cell md-label="Globe/Date/ID"
              style="margin-top: 3px; margin-bottom: 3px; padding-top: 5px; padding-bottom: 5px">
              <span class="change-color" style="font-size: 0.84rem; color: darkgreen">
                <b>{{ item.kioskID || "-" }}</b>
              </span>
              <br />
              <small style="font-weight: 600">
                {{ item.screenDate ? item.screenDate.split("T")[0].replace(/-/g, "/") : "-" }}</small>
              <br />
              <small>{{ item.packageID.slice(0, 11).toUpperCase() }}</small>
              <br />
            </md-table-cell>

            <md-table-cell md-label="Member">
              <span v-if="item.firstName || item.lastName" style="font-size: 0.97rem; font-weight: 500">{{
                item.firstName }} {{ item.lastName }}</span>
              <br v-if="item.firstName || item.lastName" />
              <small class="change-color" v-if="item.email" style="font-size: 0.8rem; color: blue">{{
                item.email
              }}</small>
              <span v-if="!item.firstName && !item.lastName && !item.email">-</span>
            </md-table-cell>

            <md-table-cell md-label="Screening">
              <small>{{ item.created_screening || "NO" }}</small>
            </md-table-cell>
            <md-table-cell md-label="Images">
              <small>{{ item.created_Screeningimages || "NO" }}</small>
            </md-table-cell>
            <md-table-cell md-label="Member">
              <small>{{ item.created_patient || "NO" }}</small>
            </md-table-cell>
            <md-table-cell md-label="Uploaded Assets">
              <small>{{ item.created_blob || "NO" }}</small>
            </md-table-cell>
            <md-table-cell md-label="Status/Finalized">
              <small>{{ item.package_status }}<br />{{ item.finalize_success }}</small>
            </md-table-cell>
            <md-table-cell md-label="Step Exception">
              <small>
                {{ item.process_step }}
                <br />
                <span :style="item.Exception === 'SUCCESS' ? 'color:#4caf50' : 'color:#f44336'">{{
                  item.Exception
                }}</span>
              </small>
            </md-table-cell>

            <md-table-cell>
              <div style="display: flex; column-gap: 5px; width: 67px">
                <md-button class="md-green"
                  :disabled="item.Exception !== 'SUCCESS' || registeredToSiview(item.packageID)"
                  @click.stop="handleRegisterSiview(item)"
                  style="position: absolute; z-index: 1000; pointer-events: all; margin-top: -14px">
                  <md-icon style="
                      margin-left: 0px !important;
                      margin-right: 30px !important;
                      padding-bottom: 6px;
                      padding-right: 14px;
                    ">
                    addchart
                  </md-icon>
                  <md-tooltip v-if="item.Exception === 'SUCCESS'" md-direction="bottom">{{
                    registeredToSiview(item.packageID) ? "Patient already registered to SiView" : "Register to SiView"
                  }}</md-tooltip>
                </md-button>

                <md-button class="md-primary" v-if="userRole === 'Admin'"
                  :disabled="item.Exception === 'SUCCESS' || isReprocessing" @click.stop="handleReprocess(item)" style="
                    position: absolute;
                    z-index: 1000;
                    pointer-events: all;
                    margin-top: -14px;
                    margin-left: 34px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  ">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" v-if="isReprocessing" md-mode="indeterminate" />
                  <md-icon v-else> refresh </md-icon>
                  <md-tooltip md-direction="bottom">Reprocess Package</md-tooltip>
                </md-button>
              </div>
            </md-table-cell>

            <md-table-cell />
          </md-table-row>
        </md-table>

        <hr v-if="!isLoading" />
        <div v-if="!isLoading" style="display: flex; align-items: center">
          <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
            <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
              <i class="fas fa-angle-double-left" />
            </a>
            <span class="page-link"
              style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px">{{ currentPage
              }}</span>
            <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
              <i class="fas fa-angle-double-right" />
            </a>
          </div>
          <div class="table table-stats" style="display: flex; justify-content: center; align-items: start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from
                <b><u>{{ startPackage }}</u></b>
                to
                <b><u>{{ endPackage }}</u></b>. Total of
                <b><u>{{ totalPackages }}</u></b>
                packages.
              </p>
            </div>
          </div>
          <md-field style="flex: 1; margin-top: 1.5rem">
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages" @change="updateLimit">
              <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </md-card-content>
    </md-card>

    <!-- NO SHOPS MODAL -->
    <md-dialog :md-active.sync="showSiviewNoShopsModal">
      <md-dialog-title>SiVIEW EMR</md-dialog-title>
      <md-dialog-content>
        <div style="width: 300px">
          We could not find any SiVIEW Shop ID configured for your organization. Please contact your administrator
        </div>
      </md-dialog-content>
      <md-dialog-actions style="justify-content: center; margin-bottom: 1rem">
        <md-button @click="showSiviewNoShopsModal = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- REGISTRATION MODAL -->

    <md-dialog v-if="selectedPatient" :md-active.sync="showSiviewRegistrationModal" :md-click-outside-to-close="false">
      <md-dialog-title>SiVIEW EMR</md-dialog-title>

      <md-dialog-content>
        <div>
          <div>
            Registering <b>{{ selectedPatient.firstName }} {{ selectedPatient.lastName }}</b> for SiVEW Refraction
          </div>
        </div>

        <div style="margin-top: 2rem">
          <md-field :class="[
            { 'md-valid': !errors.has('pd') && touched.pd },
            { 'md-form-group': false },
            { 'md-error': errors.has('pd') && touched.pd }
          ]">
            <label>Pupillary distance (between 40 and 80)</label>
            <md-input v-validate="'required|min_value:40|max_value:80'" type="text" name="pd" data-vv-name="pd"
              v-model="selected_PD"></md-input>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('pd')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('pd') && touched.pd" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
          <md-field :class="[
            { 'md-valid': !errors.has('shopId') && touched.shopId },
            { 'md-form-group': false },
            { 'md-error': errors.has('shopId') && touched.shopId }
          ]">
            <label>SiVIEW Shop ID</label>
            <md-select v-validate="'required'" v-model="selected_ShopID" name="shopId" data-vv-name="shopId"
              :disabled="!shopIds.length">
              <md-option v-for="item in shopIds" :key="item" :value="item" class="mselect">
                {{ item }}
              </md-option>
            </md-select>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('shopId')" class="error">close</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>
      </md-dialog-content>

      <md-dialog-actions style="justify-content: center; margin-bottom: 1rem">
        <md-button :disabled="isRegisteringToSiview"
          style="width: 130px; background-color: white !important; box-shadow: none; color: #000 !important"
          @click="closeSiviewRegistrationModal()">Cancel</md-button>
        <md-button class="md-primary" :disabled="isRegisteringToSiview"
          style="width: 130px; background-color: #3cb3a3 !important; color: #ffffff !important"
          @click="handleRegisterClick()"><span :class="[{ 'registering-to-siview': isRegisteringToSiview }]">{{
            isRegisteringToSiview ? "Registering..." : "Register"
          }}</span></md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog style="background-color: rgba(0, 0, 0, 0.5)" v-if="packageImages.length"
      :md-active.sync="showPackageImagesModal">
      <md-dialog-content>
        <div v-if="!imageSelected" class="images-list">
          <div style="color: #fff; position: absolute; top: 8px; right: 8px">
            <md-icon style="cursor: pointer; color: #fff" class="exit-icon"
              @click.native="showPackageImagesModal = false">cancel</md-icon>
          </div>
          <h4 style="font-weight: 500; margin-bottom: 1rem; color: #fff">Package Images</h4>
          <div style="
              margin-bottom: 1rem;
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              grid-column-gap: 10px;
              grid-row-gap: 10px;
            ">
            <div style="margin: auto" v-for="item in packageImages.filter((i) => i.file.indexOf('jpg') >= 0)">
              <img style="cursor: pointer" @click="imageSelected = item" :src="item.url" width="115px" />
            </div>
          </div>
        </div>
        <div v-if="imageSelected" class="image-details">
          <div style="color: #fff; position: absolute; top: 8px; right: 8px">
            <md-icon style="cursor: pointer; color: #fff" class="exit-icon"
              @click.native="imageSelected = null">cancel</md-icon>
          </div>
          <h4 style="margin-bottom: 1rem; font-weight: 500; color: #fff">{{ imageSelected.file }}</h4>
          <img :src="imageSelected.url" width="100%" />
        </div>
      </md-dialog-content>
    </md-dialog>

    <loader :is-visible="isLoading || isLoadingImages || isLoadingPD" />
    <package-images id="package-images" />
  </div>
</template>

<script>
import Swal from "sweetalert2"
import moment from "moment"
import loader from "@/components/GlobeChek/loader.vue"
import PackageImages from "@/components/GlobeChek/SiVIEW/package-images.vue"
import { bus } from "@/main"
import { SlideYDownTransition } from "vue2-transitions"

export default {
  components: {
    loader,
    "package-images": PackageImages,
    SlideYDownTransition
  },
  data() {
    return {
      API_SERVICE: process.env.VUE_APP_URL,
      API_ROUTE: "/pkgmgrlog/" + sessionStorage.getItem("username"),
      userRole: sessionStorage.getItem("role"),
      API_MODE: "a",
      allPackages: [],
      tableData: [],
      offset: 0,
      limit: 50,
      totalPackages: 0,
      pagination: {
        perPage: 50,
        perPageOptions: [10, 20, 50, 100, 200]
      },
      isLoading: false,
      isLoadingImages: false,
      isLoadingPD: false,
      isRegisteringToSiview: false,
      filterStatusOptions: [
        {
          label: "All",
          value: "all"
        },
        {
          label: "None",
          value: "none"
        },
        {
          label: "Processed OK",
          value: "processed-ok"
        }
      ],
      filterDateOptions: [
        {
          label: "All",
          value: "all"
        },
        {
          label: "Past day",
          value: "pastDay"
        },
        {
          label: "Past week",
          value: "pastWeek"
        },
        {
          label: "Past month",
          value: "pastMonth"
        },
        {
          label: "Past 3 months",
          value: "past3Months"
        },
        {
          label: "Past 6 months",
          value: "past6Months"
        },
        {
          label: "Past year",
          value: "pastYear"
        }
      ],
      currentOrganization:
        JSON.parse(sessionStorage.getItem("organizations")).length === 1
          ? JSON.parse(sessionStorage.getItem("organizations"))[0].orgId
          : localStorage.getItem("currentOrgSelectedForFilters") || "all",
      organizations: [
        { label: "All", value: "all" },
        ...JSON.parse(sessionStorage.getItem("organizations")).map((i) => {
          return {
            label: i.orgName,
            value: i.orgId
          }
        })
      ],
      selectedPatient: null,
      selected_ShopID: null,
      selected_PD: null,
      showSiviewRegistrationModal: false,
      showSiviewNoShopsModal: false,
      currentSearchTxt: "",
      currentFilterDate: "all",
      currentFilterDownloaded: "all",
      currentFilterStatus: "all",
      shopIds: [],
      touched: {
        pd: false,
        shopId: false
      },
      packageImages: [],
      showPackageImagesModal: false,
      imageSelected: null,
      isReprocessing: false,
      allSiviewPatients: []
    }
  },
  computed: {
    // Returns a page from the searched data or the whole data. Search is performed in the watch section below
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.totalPackages
    },
    startPackage() {
      return this.offset + 1
    },
    endPackage() {
      return Math.min(this.offset + this.limit, this.totalPackages) || 1
    }
  },
  watch: {
    "pagination.perPage"(newLimit) {
      this.limit = newLimit
      this.offset = 0
      this.fetchPackages()
    }
  },
  methods: {
    closeSiviewRegistrationModal() {
      this.showSiviewRegistrationModal = false
      this.touched.pd = false
      this.touched.shopId = false
      this.selectedPatient = null
    },
    async handleSearch() {
      this.offset = 0;
      await this.fetchPackages();
    },
    async handleRefresh() {
      await this.fetchPackages()
    },
    async fetchShops() {
      try {
        const url = this.API_SERVICE + "/siview/user/" + sessionStorage.getItem("userID") + "/shops"
        const config = { headers: { "Content-Type": "application/json" } }
        const data = null
        const shopIds = await window.axios.get(url, data, config).then((r) => r.data.map((i) => i.shopId))
        this.shopIds = Array.from(new Set(shopIds))
        await this.fetchPatients()
      } catch (e) {
        console.log(e)
      }
    },
    getSelectedPD(item) {
      this.isLoadingPD = true
      const url = this.API_SERVICE + "/getpd/" + item.packageID
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null
      return (
        window.axios
          .get(url, data, config)
          // .then(r => console.log("getpd: " + r.data))
          .then((r) => (this.selected_PD = r.data))
          .catch(function (error) {
            console.log(error)
          })
          .finally(() => {
            this.isLoadingPD = false
          })
      )
    },
    async handleReprocess(item) {
      const url = this.API_SERVICE + "/package-manager/reprocess/" + item.packageID
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null
      this.isReprocessing = true
      await window.axios
        .put(url, data, config)
        .then(() => {
          setTimeout(() => {
            this.isReprocessing = false
            Swal.fire({
              title: "Success",
              text: "The package was reprocessed successfully",
              icon: "success",
              confirmButtonText: "OK"
            })
            this.handleRefresh()
          }, 30000)
        })
        .catch((error) => {
          console.log(error)
          setTimeout(() => {
            this.isReprocessing = false
          }, 30000)
        })
    },
    async handleRegisterSiview(item) {
      if (!this.shopIds.length) {
        this.showSiviewNoShopsModal = true
        return
      }
      await this.getSelectedPD(item)
      if (this.shopIds.length === 1) {
        this.selected_ShopID = this.shopIds[0]
      }
      this.selectedPatient = item
      this.showSiviewRegistrationModal = true
    },
    async handleRegisterClick() {
      this.touched.pd = true
      this.touched.shopId = true
      const item = this.selectedPatient
      return this.$validator.validateAll().then(async (valid) => {
        if (!valid) return
        const data = {
          shopId: this.selected_ShopID,
          patient: {
            firstName: item.firstName,
            lastName: item.lastName,
            email: item.email,
            pupillaryDistance: this.selected_PD
          }
        }
        const res = await this.registerForSiVIEW(item, data)
        if (res.success) {
          this.closeSiviewRegistrationModal()
          Swal.fire({
            title: "SiVIEW Registration Success!",
            text: `${item.firstName} ${item.lastName} is now registered with SiVIEW for Refraction.`,
            type: "success",
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false
          }).then((result) => {
            if (result.value) {
              this.$router.push(`${sessionStorage.getItem("portalRoute")}/siview`)
            }
          })
        } else {
          Swal.fire({
            type: "error",
            title: "Oops...",
            text: "Error trying to register this patient to SiVIEW. Try again later"
          })
        }
      })
    },
    convertAXIS(ax) {
      if (ax == "180") {
        return "0"
      } else {
        return ax
      }
    },
    convertCYL(cyl) {
      let val = cyl.split(" ")[1].replace("+", "").replace("-", "")

      return "-" + val
      // return (val >= 0 ? "+" : "-") + val;                                                   //BASELINE
    },
    registerForSiVIEW(item, pInfo) {
      this.isRegisteringToSiview = true
      console.log("item: ", item)
      console.log("pInfo: ", pInfo)

      const url = this.API_SERVICE + "/siviewreg/" + item.packageID
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null

      return window.axios
        .get(url, data, config)
        .then((response) => {
          console.log("Get Registration Info: ", response.data)

          let odAR = response.data.visionAutoRefractionOD
          let osAR = response.data.visionAutoRefractionOS

          let odSPH = null
          let odCYL = null
          let odAXS = null

          let osSPH = null
          let osCYL = null
          let osAXS = null

          let plusCyl = odAR.split(" ")[1].indexOf("-") != -1 ? false : true

          console.log("*** ORIGINAL VALUES ***")
          console.log("odAR: " + "(" + odAR.split(" ")[0] + "|" + odAR.split(" ")[1] + "|" + odAR.split(" ")[3] + ")")
          console.log("osAR: " + "(" + osAR.split(" ")[0] + "|" + osAR.split(" ")[1] + "|" + osAR.split(" ")[3] + ")")

          if (plusCyl === true) {
            // PLUS CYL Conversion
            odSPH = Number((Number(odAR.split(" ")[0]) + Number(odAR.split(" ")[1])) * 1).toFixed(2)
            odCYL = Number(Number(odAR.split(" ")[1]) * -1.0 * 1).toFixed(2)
            odAXS = Number(odAR.split(" ")[3]) <= 91 ? Number(odAR.split(" ")[3]) + 90 : Number(odAR.split(" ")[3]) - 90

            osSPH = Number((Number(osAR.split(" ")[0]) + Number(osAR.split(" ")[1])) * 1).toFixed(2)
            osCYL = Number(Number(osAR.split(" ")[1]) * -1.0 * 1).toFixed(2)
            osAXS = Number(osAR.split(" ")[3]) <= 91 ? Number(osAR.split(" ")[3]) + 90 : Number(osAR.split(" ")[3]) - 90
            odAXS = this.convertAXIS(odAR.split(" ")[3])
            osAXS = this.convertAXIS(osAR.split(" ")[3])
          } else {
            // MINUS CYL
            odSPH = odAR.split(" ")[0]
            odCYL = odAR.split(" ")[1]
            odAXS = this.convertAXIS(odAR.split(" ")[3])

            osSPH = osAR.split(" ")[0]
            osCYL = osAR.split(" ")[1]
            osAXS = this.convertAXIS(osAR.split(" ")[3])
          }

          console.log("*** ADJUSTEDVALUES ***")
          console.log("IS PlusCyl ?", plusCyl)
          console.log("odAR: " + "(" + odSPH + "|" + odCYL + "|" + odAXS + ")")
          console.log("osAR: " + "(" + osSPH + "|" + osCYL + "|" + osAXS + ")")

          const Registration = {
            firstname: item.firstName,
            lastname: item.lastName,
            initials: `${item.firstName[0]}${item.lastName[0]}`,

            birthdate: moment(response.data.DOB).format("YYYY-MM-DD"),
            year_of_birth: moment(response.data.DOB).format("YYYY"),
            age: moment().diff(response.data.DOB, "years"),

            language: "en-US",
            phone: response.data.cellNumber,
            file_number: item.screeningID.replaceAll("-", ""),
            client_number: item.packageID,
            web_emr_id: item.email + "_" + Math.floor(Math.random() * 1000),

            start_measurements: [
              {
                type: "AUTOREF",
                pupillary_distance: pInfo.patient.pupillaryDistance,
                od: {
                  sphere: odSPH,
                  cylinder: odCYL,
                  axis: odAXS,

                  corneal_asigmatism_cylinder: 0,
                  corneal_astigmatism_axis: 0,
                  add: 0
                },
                os: {
                  sphere: osSPH,
                  cylinder: osCYL,
                  axis: osAXS,

                  corneal_asigmatism_cylinder: 0,
                  corneal_astigmatism_axis: 0,
                  add: 0
                }
              }
            ]
          }

          console.log("Registration: ", Registration)
          // ITS NOT USING THE ORGANIZATION ID
          const url = `${this.API_SERVICE}/siview/${sessionStorage.getItem("userOrgID")}/shops/${pInfo.shopId}/patients`
          const config = { headers: { "Content-Type": "application/json" } }
          const data = Registration
          return window.axios.post(url, data, config).then((pt) => {
            return { success: true, message: pt }
          })
        })
        .catch((error) => {
          console.log(error)
          return { success: false, message: error }
        })
        .finally(() => {
          this.isRegisteringToSiview = false
        })
    },
    async openPackageImages(item) {
      try {
        this.isLoadingImages = true
        const url = `${this.API_SERVICE}/images/${item.packageID}`
        const config = { headers: { "Content-Type": "application/json" } }
        const imagesResponse = await window.axios.get(url, config).then((r) => r.data)
        const images = []
        for (const img of imagesResponse) {
          // remove duplicate images from array
          if (!images.find((i) => i.file === img.file)) {
            images.push(img)
          }
        }
        this.packageImages = images
        this.showPackageImagesModal = true
        this.imageSelected = null
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoadingImages = false
      }
    },
    async fetchPackages() {
      if (this.isLoading) return
      this.isLoading = true
      try {
        const url = this.API_SERVICE + this.API_ROUTE
        const config = {
          headers: { "Content-Type": "application/json" },
          params: {
            search: this.currentSearchTxt,
            dateFilter: this.currentFilterDate,
            orgFilter: this.currentOrganization,
            status: this.currentFilterStatus,
            limit: this.limit,
            offset: this.offset
          }
        }

        const response = await window.axios.get(url, config).then((r) => r.data)
        this.allPackages = response.items || []
        this.totalPackages = response.total || 0
        this.tableData = this.allPackages
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    updateLimit(newLimit) {
      this.offset = 0
      this.limit = newLimit
      this.fetchPackages()
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.fetchPackages()
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.fetchPackages()
      }
    },
    async fetchPatients() {
      const url = this.API_SERVICE + "/siview/" + sessionStorage.getItem("userOrgID") + "/patients"
      const config = { headers: { "Content-Type": "application/json" } }
      const data = { params: { shopIds: this.shopIds.join(",") } }

      window.axios
        .get(url, data, config)
        .then((r) => r.data)
        .then((patients) => {
          this.allSiviewPatients = patients
        })
        .catch(function (error) {
          console.error(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    registeredToSiview(packageId) {
      return !!this.allSiviewPatients.find((i) => i.client_number === packageId)
    }
  },
  mounted() {
    Promise.all([this.fetchPackages(), this.fetchShops()]).finally(() => {
      this.isLoading = false
    })
    bus.$on("toggleImgBox", () => {
      this.isLoadingImages = false
    })
  }
}
</script>

<style lang="scss" scoped>
.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 0.85rem;
  height: 38px;
}

.md-table-row {
  color: rgb(0, 6, 97);
}

.md-table-row:hover {
  background-color: #0077ff !important;
  color: white;

  .change-color {
    color: white !important;
  }
}

.table-striped {
  tbody>tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody>tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.md-table-row.md-selected-single {
  font-weight: 400;
  font-size: 0.95rem;
  color: white;
  background-color: #00418b !important;

  .change-color {
    color: white !important;
  }
}

.md-button.md-green {
  background-color: #3cb3a3 !important;
  color: #ffffff !important;
}

.md-button.md-green[disabled] {
  opacity: 0.3;
}

// .md-icon {
//   margin-left: 24px !important;
// }

#headers {
  transition: none;
  background-color: #edf2f7 !important;
}

.dropdown-menu {
  li {
    padding: 3px 3px 3px 5px;
  }

  li:hover {
    background-color: #005ac2 !important;
    color: #fff !important;
  }
}

.isRead {
  color: rgb(2, 171, 16);
  font-weight: 500;
  font-size: 0.87rem;
}

.isEDIT {
  color: rgb(2, 171, 16);
  font-weight: 500;
  font-size: 0.87rem;
  background-color: #e6ffe6 !important;
}

.md-table-row.isEDIT:hover {
  background-color: #ccffcc !important;
  color: #000000 !important;
}

.md-button.md-grey {
  background-color: #d3d3d3 !important;
  color: #808080 !important;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination-container span {
  margin: 0 15px;
}

#package-images {
  //top: 0;
  //position: fixed;
  max-width: 500px; //1250px;
  z-index: 100;
  width: 95%;
  margin: 0px;
  padding: 0px;
  //display: inline-block;
  //@debugvertical-align: top;
}

.registering-to-siview {
  clip-path: inset(0 1ch 0 0);
  animation: l 1s steps(4, jump-none) infinite;
}

@keyframes l {
  to {
    clip-path: inset(0);
  }
}
</style>
